export function isOrderPreviewCountry(country) {
  return orderPreviewCountries.includes(country);
}
var orderPreviewCountries = ['AT', 'BE', 'BG', 'CA', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HR', 'HU', 'ID', 'IE', 'IN', 'IT', 'KE', 'KR', 'LT', 'LU', 'LV', 'MT', 'NL', 'NZ', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK', 'TR'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/components/OrderPreviewWrapper/helpers.js
// module id = 4660
// module chunks = 11